export const regionOptions = [
  { value: 'Greater Accra', label: 'Greater Accra' },
  { value: 'Ashanti', label: 'Ashanti' },
  { value: 'Western', label: 'Western' },
  { value: 'Eastern', label: 'Eastern' },
  { value: 'Central', label: 'Central' },
  { value: 'Northern', label: 'Northern' },
  { value: 'Volta', label: 'Volta' },
  { value: 'Bono', label: 'Bono' },
  { value: 'Upper East', label: 'Upper East' },
  { value: 'Upper West', label: 'Upper West' },
  { value: 'Western North', label: 'Western North' },
  { value: 'Oti', label: 'Oti' },
  { value: 'Bono East', label: 'Bono East' },
  { value: 'Ahafo', label: 'Ahafo' },
  { value: 'Savannah', label: 'Savannah' },
  { value: 'North East', label: 'North East' }
];

export const locationsByRegion = {
  'Greater Accra': [
    'Accra Central',
    'East Legon',
    'Osu',
    'Tema',
    'Madina',
    'Adenta',
    'Teshie',
    'Nungua',
    'Spintex',
    'Labadi',
    'Dansoman',
    'Kaneshie',
    'Darkuman',
    'Lapaz',
    'Achimota',
    'Airport Residential',
    'Cantonments',
    'Labone',
    'Ridge',
    'Roman Ridge',
    'Abokobi',
    'Ablekuma',
    'Aburi',
    'Accra New Town',
    'Adentan',
    'Agbogba',
    'Agbogbloshie',
    'Amasaman',
    'Ashaiman',
    'Awoshie',
    'Baatsona',
    'Chorkor',
    'Dome',
    'Ga East',
    'Ga West',
    'Gbawe',
    'James Town',
    'Kpone',
    'Kwabenya',
    'Lartebiokorshie',
    'Mallam',
    'Mamprobi',
    'McCarthy Hill',
    'North Kaneshie',
    'Oyarifa',
    'Pantang',
    'Pokuase',
    'Sakumono',
    'Santa Maria',
    'Sowutuom',
    'Taifa',
    'Tesano',
    'Tetegu',
    'Weija',
    'Winneba Junction'
  ],
  'Ashanti': [
    'Kumasi Central',
    'Adum',
    'Kejetia',
    'Bantama',
    'Nhyiaeso',
    'Asokwa',
    'Ahodwo',
    'Santasi',
    'Abrepo',
    'Manhyia',
    'Asafo',
    'Suame',
    'Tafo',
    'Kwadaso',
    'Patasi',
    'Adansi',
    'Afigya Kwabre',
    'Ahafo Ano North',
    'Ahafo Ano South',
    'Amansie Central',
    'Amansie West',
    'Asante Akim Central',
    'Asante Akim North',
    'Asante Akim South',
    'Atwima Kwanwoma',
    'Atwima Mponua',
    'Atwima Nwabiagya',
    'Bekwai',
    'Bosome Freho',
    'Bosomtwe',
    'Ejisu Juaben',
    'Ejura Sekyedumase',
    'Kwabre East',
    'Kumasi Metro',
    'Mampong',
    'Obuasi',
    'Ofinso',
    'Ofinso North',
    'Old Tafo',
    'Sekyere Afram Plains',
    'Sekyere Central',
    'Sekyere East',
    'Sekyere South'
  ],
  'Western': [
    'Sekondi',
    'Takoradi',
    'Tarkwa',
    'Axim',
    'Agona Nkwanta',
    'Kwesimintsim',
    'Market Circle',
    'New Takoradi',
    'Apremdo',
    'Kojokrom',
    'Ahanta West',
    'Amenfi Central',
    'Amenfi East',
    'Amenfi West',
    'Ellembelle',
    'Jomoro',
    'Mpohor',
    'Nzema East',
    'Prestea Huni Valley',
    'Sekondi Takoradi Metro',
    'Shama',
    'Tarkwa Nsuaem',
    'Wasa Amenfi Central',
    'Wasa Amenfi East',
    'Wasa Amenfi West'
  ],
  'Eastern': [
    'Koforidua',
    'Nkawkaw',
    'Nsawam',
    'Akim Oda',
    'Akropong',
    'Somanya',
    'Asamankese',
    'Aburi',
    'Akosombo',
    'Begoro',
    'Abuakwa North',
    'Abuakwa South',
    'Afram Plains North',
    'Afram Plains South',
    'Akim West',
    'Akuapim North',
    'Akuapim South',
    'Asene Manso Akroso',
    'Atiwa East',
    'Atiwa West',
    'Ayensuano',
    'Birim Central',
    'Birim North',
    'Birim South',
    'Denkyembour',
    'Fanteakwa North',
    'Fanteakwa South',
    'Kwaebibirem',
    'Kwahu Afram Plains North',
    'Kwahu Afram Plains South',
    'Kwahu East',
    'Kwahu South',
    'Kwahu West',
    'New Juaben North',
    'New Juaben South',
    'Okere',
    'Suhum',
    'Upper Manya Krobo',
    'West Akim',
    'Yilo Krobo'
  ],
  'Central': [
    'Cape Coast',
    'Winneba',
    'Kasoa',
    'Mankessim',
    'Elmina',
    'Swedru',
    'Budumburam',
    'Saltpond',
    'Moree',
    'Apam',
    'Abura Asebu Kwamankese',
    'Agona East',
    'Agona West',
    'Ajumako Enyan Essiam',
    'Asikuma Odoben Brakwa',
    'Assin Central',
    'Assin North',
    'Assin South',
    'Awutu Senya East',
    'Awutu Senya West',
    'Cape Coast Metro',
    'Effutu',
    'Ekumfi',
    'Gomoa Central',
    'Gomoa East',
    'Gomoa West',
    'Hemang Lower Denkyira',
    'Komenda Edina Eguafo Abirem',
    'Mfantsiman',
    'Twifo Atti Mokwa',
    'Twifo Heman Lower Denkyira',
    'Upper Denkyira East',
    'Upper Denkyira West'
  ],
  'Northern': [
    'Tamale',
    'Yendi',
    'Savelugu',
    'Gushegu',
    'Karaga',
    'Kumbungu',
    'Sagnarigu',
    'Tolon',
    'Zabzugu',
    'Mion',
    'Central Gonja',
    'East Gonja',
    'Kpandai',
    'Nanumba North',
    'Nanumba South',
    'North Gonja',
    'Saboba',
    'Tatale Sanguli',
    'West Gonja'
  ],
  'Volta': [
    'Ho',
    'Keta',
    'Hohoe',
    'Aflao',
    'Kpando',
    'Anloga',
    'Akatsi',
    'Dzodze',
    'Peki',
    'Sogakope',
    'Adaklu',
    'Agotime Ziope',
    'Akatsi North',
    'Akatsi South',
    'Central Tongu',
    'Ho Municipal',
    'Ho West',
    'Hohoe Municipal',
    'Jasikan',
    'Kadjebi',
    'Keta Municipal',
    'Ketu North',
    'Ketu South',
    'Kpando Municipal',
    'Krachi East',
    'Krachi Nchumuru',
    'Krachi West',
    'Nkwanta North',
    'Nkwanta South',
    'North Dayi',
    'North Tongu',
    'South Dayi',
    'South Tongu'
  ],
  'Bono': [
    'Sunyani',
    'Berekum',
    'Dormaa Ahenkro',
    'Wenchi',
    'Nsoatre',
    'Sampa',
    'New Drobo',
    'Jinijini',
    'Wamfie',
    'Banda Ahenkro',
    'Banda',
    'Berekum Municipal',
    'Dormaa Central',
    'Dormaa East',
    'Dormaa West',
    'Jaman North',
    'Jaman South',
    'Sunyani Municipal',
    'Sunyani West',
    'Tain',
    'Wenchi Municipal'
  ],
  'Upper East': [
    'Bolgatanga',
    'Navrongo',
    'Bawku',
    'Zebilla',
    'Sandema',
    'Paga',
    'Tongo',
    'Pusiga',
    'Binaba',
    'Garu',
    'Bawku Municipal',
    'Bawku West',
    'Binduri',
    'Bolgatanga Municipal',
    'Builsa North',
    'Builsa South',
    'Garu Tempane',
    'Kassena Nankana East',
    'Kassena Nankana West',
    'Nabdam',
    'Talensi'
  ],
  'Upper West': [
    'Wa',
    'Tumu',
    'Lawra',
    'Nandom',
    'Jirapa',
    'Lambussie',
    'Nadowli',
    'Kaleo',
    'Funsi',
    'Gwollu',
    'Daffiama Bussie Issa',
    'Jirapa Municipal',
    'Lambussie Karni',
    'Lawra Municipal',
    'Nadowli Kaleo',
    'Nandom Municipal',
    'Sissala East',
    'Sissala West',
    'Wa East',
    'Wa Municipal',
    'Wa West'
  ],
  'Western North': [
    'Sefwi Wiawso',
    'Bibiani',
    'Enchi',
    'Juaboso',
    'Essam',
    'Akontombra',
    'Adabokrom',
    'Bodi',
    'Dadieso',
    'Sewhi Bekwai',
    'Akontombra',
    'Aowin',
    'Bibiani Anhwiaso Bekwai',
    'Bodi',
    'Juaboso',
    'Sefwi Akontombra',
    'Sefwi Wiawso Municipal',
    'Suaman'
  ],
  'Oti': [
    'Dambai',
    'Kadjebi',
    'Jasikan',
    'Nkwanta',
    'Worawora',
    'Brewaniase',
    'Kwamekrom',
    'Kete Krachi',
    'Chinderi',
    'Banda Kakyire',
    'Biakoye',
    'Jasikan Municipal',
    'Kadjebi',
    'Krachi East',
    'Krachi Nchumuru',
    'Krachi West',
    'Nkwanta North',
    'Nkwanta South'
  ],
  'Bono East': [
    'Techiman',
    'Kintampo',
    'Nkoranza',
    'Atebubu',
    'Yeji',
    'Kwame Danso',
    'Prang',
    'Kajaji',
    'Jema',
    'Abease',
    'Atebubu Amantin',
    'Kintampo North Municipal',
    'Kintampo South',
    'Nkoranza North',
    'Nkoranza South Municipal',
    'Pru East',
    'Pru West',
    'Sene East',
    'Sene West',
    'Techiman Municipal',
    'Techiman North'
  ],
  'Ahafo': [
    'Goaso',
    'Bechem',
    'Duayaw Nkwanta',
    'Hwidiem',
    'Kenyasi',
    'Kukuom',
    'Mim',
    'Acherensua',
    'Sankore',
    'Yamfo',
    'Asunafo North Municipal',
    'Asunafo South',
    'Asutifi North',
    'Asutifi South Municipal',
    'Tano North Municipal',
    'Tano South'
  ],
  'Savannah': [
    'Damongo',
    'Salaga',
    'Bole',
    'Sawla',
    'Buipe',
    'Daboya',
    'Bamboi',
    'Tinga',
    'Mandari',
    'Kalba',
    'Bole',
    'Central Gonja',
    'East Gonja Municipal',
    'North Gonja',
    'Sawla Tuna Kalba',
    'West Gonja Municipal'
  ],
  'North East': [
    'Nalerigu',
    'Walewale',
    'Gambaga',
    'Chereponi',
    'Bunkpurugu',
    'Yunyoo',
    'Nakpanduri',
    'Lamgbinsi',
    'Nasuan',
    'Wungu',
    'Bunkpurugu Yunyoo',
    'Chereponi',
    'East Mamprusi Municipal',
    'Mamprugu Moagduri',
    'West Mamprusi Municipal',
    'Yunyoo Nasuan'
  ]
};

export const commonDistricts = [
  "Ablekuma Central",
  "Ablekuma North",
  "Ablekuma South",
  "Ablekuma West",
  "Accra Metropolitan",
  "Adabraka",
  "Adentan",
  "Agona East",
  "Agona West",
  "Ahafo Ano North",
  "Ahafo Ano South",
  "Akuapem North",
  "Akuapem South",
  "Amansie Central",
  "Amansie East",
  "Amansie West",
  "Asante Akim Central",
  "Asante Akim North",
  "Asante Akim South",
  "Ashanti Mampong",
  "Asunafo North",
  "Asunafo South",
  "Atwima Kwanwoma",
  "Atwima Mponua",
  "Atwima Nwabiagya",
  "Awutu Senya East",
  "Awutu Senya West",
  "Bekwai",
  "Birim Central",
  "Birim North",
  "Birim South",
  "Bosome Freho",
  "Bosomtwe",
  "Bunkpurugu Yunyoo",
  "Cape Coast Metropolitan",
  "Central Tongu",
  "Dangme East",
  "Dangme West",
  "East Gonja",
  "East Mamprusi",
  "Ejisu Juaben",
  "Ejura Sekyedumase",
  "Fanteakwa",
  "Ga Central",
  "Ga East",
  "Ga South",
  "Ga West",
  "Gomoa Central",
  "Gomoa East",
  "Gomoa West",
  "Ho Municipal",
  "Jaman North",
  "Jaman South",
  "Kasena Nankana East",
  "Kasena Nankana West",
  "Keta",
  "Ketu North",
  "Ketu South",
  "Kintampo North",
  "Kintampo South",
  "Komenda Edina Eguafo Abirem",
  "Kpando",
  "Kwabre East",
  "Kwahu East",
  "Kwahu South",
  "Kwahu West",
  "La Dade Kotopon",
  "La Nkwantanang Madina",
  "Ledzokuku Krowor",
  "Mampong",
  "Mfantsiman",
  "New Juaben East",
  "New Juaben South",
  "Nkoranza North",
  "Nkoranza South",
  "North Tongu",
  "Obuasi East",
  "Obuasi West",
  "Ofinso North",
  "Ofinso South",
  "Okere",
  "Pru East",
  "Pru West",
  "Sagnarigu",
  "Sawla Tuna Kalba",
  "Sekondi Takoradi Metropolitan",
  "South Tongu",
  "Sunyani Municipal",
  "Sunyani West",
  "Tamale Metropolitan",
  "Tamale North",
  "Tamale South",
  "Techiman Municipal",
  "Techiman North",
  "Tema Metropolitan",
  "Tema West",
  "Twifo Atti Mokwa",
  "Wa East",
  "Wa Municipal",
  "Wa West",
  "West Gonja",
  "West Mamprusi",
  "Yendi Municipal",
  "Other",
];